import FavoriteAnimation from './favorite_animation'

export default FavoriteAnimation
